import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SectionHeader from '../../SectionHeader';
import FormGroup from '../../FormGroup';
import TablePagination from '../../TablePaginationComponent';
import usePostData from '../../../hooks/usePostData';
import inviteCustomersFields from './inviteCustomersFields';

const InviteCustomers = ({ organizationId, onInviteSuccess }) => {
  //   console.log('onError', onError);
  const [showInviteCustomers, setShowInviteCustomers] = useState(false);
  const [invitedCustomers] = useState([]); // TODO: Implement fetching invited customers
  const [errFun, setErrFun] = useState();

  const {
    postData: postInviteData,
    res: inviteRes,
    error: inviteError
  } = usePostData();

  // Handle invite customers functionality
  const handleInviteCustomers = () => {
    setShowInviteCustomers(!showInviteCustomers);
  };

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });

    const emails = data.emails.split('\n').filter((email) => email.trim());
    if (emails.length === 0) {
      setError('emails', {
        type: 'required',
        message: 'יש להזין לפחות כתובת מייל אחת'
      });
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const invalidEmails = emails.filter(
      (email) => !emailRegex.test(email.trim())
    );
    if (invalidEmails.length > 0) {
      setError('emails', {
        type: 'pattern',
        message: 'יש כתובות מייל לא תקינות'
      });
      return;
    }

    const invitationData = {
      organizationId: organizationId,
      productId: data.productId,
      emails: emails
    };

    postInviteData('invitations/bulk', invitationData);
  };

  // Handle invite API response
  useEffect(() => {
    if (inviteError) {
      errFun?.set('apiError', {
        type: 'string',
        message: inviteError.apiError || 'שגיאה בשליחת הזמנות'
      });
    } else if (inviteRes) {
      onInviteSuccess('הזמנות נשלחו בהצלחה');
      setShowInviteCustomers(false);
      // TODO: Refresh invited customers list
    }
  }, [inviteRes, inviteError, errFun]);

  return (
    <div className="invite-customers-component">
      {/* Invite Customers Section */}
      <div className="invite-customers-section">
        <SectionHeader
          title="הזמן לקוחות"
          newItem={{
            handleClick: handleInviteCustomers,
            txt: showInviteCustomers ? 'ביטול' : 'הזמן לקוחות'
          }}
        />

        {showInviteCustomers && (
          <div className="invite-form">
            <FormGroup
              fields={inviteCustomersFields(organizationId)}
              onSubmit={onSubmit}
              txt="שלח הזמנות"
              errMsg={inviteError}
            />
          </div>
        )}
      </div>

      {/* Invited Customers Table */}
      {invitedCustomers?.length > 0 && (
        <div className="invited-customers-list">
          <SectionHeader title="לקוחות מוזמנים" />
          <TablePagination
            headers={['שם מוצר', 'מייל', 'תאריך הזמנה', 'סטטוס']}
            columns={[
              { value: 'productName', sort: true },
              { value: 'email', sort: true },
              { value: 'inviteDate', sort: true },
              { value: 'status', sort: true }
            ]}
            rows={invitedCustomers}
            pagination={true}
          />
        </div>
      )}
    </div>
  );
};

InviteCustomers.propTypes = {
  organizationId: PropTypes.string.isRequired,
  onInviteSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func
};

export default InviteCustomers;
